module.exports = __webpack_public_path__ + "img/speakers-wht.2c2810f3.svg";